var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconSummaryPresentation = function SvgIconSummaryPresentation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20.163 25.717-6.418 6.433a.725.725 0 0 1-1.029 0l-.505-.508a.726.726 0 0 1 0-1.027l6.42-6.436 1.532 1.536v.002Z",
    fill: "#3987F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m19.83 25.717 6.418 6.433a.725.725 0 0 0 1.03 0l.505-.508a.726.726 0 0 0 0-1.027l-6.42-6.436-1.533 1.536v.002Z",
    fill: "#3987F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.906 31.637v-6.546h2.182v6.546a.727.727 0 0 1-.727.727h-.727a.727.727 0 0 1-.728-.727Z",
    fill: "#3987F8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.088 9.818h21.818v14.546c0 .803-.65 1.454-1.454 1.454h-18.91a1.454 1.454 0 0 1-1.454-1.454V9.818Z",
    fill: "#D1E6FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.36 9.818h23.272a.727.727 0 0 0 .727-.727v-.727a.727.727 0 0 0-.727-.727H8.36a.727.727 0 0 0-.727.727v.727c0 .402.326.727.727.727Z",
    fill: "#3987F8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.725 22.454a1.001 1.001 0 0 1-.707-1.707l4.363-4.364a1 1 0 0 1 1.415 0l2.202 2.202 6.565-6.565a1 1 0 1 1 1.415 1.414l-7.273 7.273a1 1 0 0 1-1.414 0l-2.202-2.202-3.657 3.657a.998.998 0 0 1-.707.292Z",
    fill: "#2C6CCC"
  })));
};
export default SvgIconSummaryPresentation;